import { useRoutes } from "react-router-dom";
import Layout from "../layout/Layout";
import BanquetLayout from "../layout/BanquetLayout";
import GuestPage from "../pages/GuestPage";
import BanquetPage from "../pages/BanquetPage";
import CeremonyPage from "../pages/CeremonyPage";
import TimelinePage from "../pages/TimelinePage";
import MapPage from "../pages/MapPage";
const AppRoutes = () => {
  return useRoutes([
    {
      path: "/", 
      element: <Layout />,
      children: [
        {
          index: true, 
          element: <GuestPage />,
        }
      ],
    },
    {
      path: "/",
      element: <BanquetLayout />,
      children: [
        {
          path: "/banquet", 
          element: <BanquetPage />,
        },
        {
          path: "/ceremony",
          element: <CeremonyPage />,
        },
        {
          path: "/timeline",
          element: <TimelinePage />,
        },
        {
          path: "/map",
          element: <MapPage />,
        }
      ],
    }
  ]);
};

export default AppRoutes;
